<template>
  <div class="controls-wrapper">
    <icon-button icon="el-icon-close" v-if="leftControl" @click.stop.prevent="removeStation"/>
    <icon-button icon="el-icon-edit"  v-else @click.stop.prevent="showDialog = true" />

    <el-dialog :append-to-body="true" v-if="showDialog" append-to-body width="800px" top="2vh" custom-class="dialog-no-padding" :visible.sync="showDialog">
      <upsert-form v-if="showDialog" :station="station" @update="update" />
    </el-dialog>

  </div>
</template>

<script>
import UpsertForm from './../UpsertForm'

export default {
  name: 'StationControls',
  components: { UpsertForm },
  props: {
    station: {
      type: Object,
      required: true
    },
    leftControl: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    update (updatedStation) {
      console.log(updatedStation)
      this.showDialog = false
      this.$emit('update', this.station, updatedStation)
    },
    removeStation () {
      this.$confirm(`Delete station ${this.station.name}?`, 'Are you sure?', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await this.$http.delete(this.$api.stations.delete(this.station.id))
        this.$message.success('Station deleted')
        this.$emit('remove', this.station)
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/system/StationControls.vue